import actionTypes from '../constants/action-types';

const blocks = (state = [], action) => {
  if (action.type !== actionTypes.SET_BLOCKS) return state;
  return action.payload.blocks;
};

export default blocks;
